/* eslint-disable @typescript-eslint/no-namespace */
declare module globalThis {
	let msCrypto: Crypto;
}

//This is from https://github.com/nastyox/Rando.js/blob/2.0.0-cryptographically-secure-version/code/plain-javascript/2.0.0/rando.js#L7-L22
export function getRandomValue(): number {
	try {
		let cryptoRandoms, cryptoRandom;
		const cryptoRandomSlices = [];

		while ((cryptoRandom = '.' + cryptoRandomSlices.join('')).length < 30) {
			cryptoRandoms = (window.crypto || globalThis.msCrypto).getRandomValues(new Uint32Array(5));

			for (let i = 0; i < cryptoRandoms.length; i++) {
				const cryptoRandomSlice = cryptoRandoms[i] < 4000000000 ? cryptoRandoms[i].toString().slice(1) : '';

				if (cryptoRandomSlice.length > 0) {
					cryptoRandomSlices[cryptoRandomSlices.length] = cryptoRandomSlice;
				}
			}
		}

		return Number(cryptoRandom);
	} catch (e) {
		return Math.random();
	}
}

/**
 * Get a random integer between min (inclusive) and max (exclusive)
 * @param {number} min 
 * @param {number} max 
 * @returns number
 */
export function getRandomInt(min: number, max: number): number {
	const minCeiled = Math.ceil(min);
	const maxFloored = Math.floor(max);
	return Math.floor(getRandomValue() * (maxFloored - minCeiled) + minCeiled);
}
